import Cookies from 'js-cookie'

const defaultAttributes = {
  path: '/',
  sameSite: 'None',
  secure: true
}

const TOKEN_NAME = 'token'

let t = ''

const isLocalhost = function () {
  return location.hostname === 'localhost'
}

const getAttributes = function (attributes) {
  return Object.assign({}, defaultAttributes, attributes)
}

const cookie = {
  set: function (name, value, attributes) {
    if (name === TOKEN_NAME) {
      t = value
      if (!isLocalhost()) return
    }
    Cookies.set(name, value, getAttributes(attributes))
  },
  get: function (name) {
    if (name !== TOKEN_NAME) return Cookies.get(name)
    if (!t && isLocalhost()) t = Cookies.get(name) || ''
    return t
  },
  remove: function (name, attributes) {
    if (name === TOKEN_NAME) {
      t = ''
      if (!isLocalhost()) return
    }
    Cookies.remove(name, getAttributes(attributes))
  }
}

export default cookie
